// ** MUI Imports
import { Theme } from '@mui/material/styles'

// ** Theme Type Import
import { Skin } from 'src/@core/layouts/types'
import { foundationTokens } from 'src/components/foundations'

const Snackbar = (theme: Theme, skin: Skin) => {
  return {
    MuiSnackbarContent: {
      styleOverrides: {
        root: {
          borderRadius: foundationTokens.radius.control,
          boxShadow: theme.shadows[skin === 'bordered' ? 0 : foundationTokens.shadow.floating],
          ...(skin === 'bordered' && { border: `1px solid ${theme.palette.divider}` }),
          backgroundColor: `rgb(${theme.palette.customColors.main})`,
          color: theme.palette.common[theme.palette.mode === 'light' ? 'white' : 'black']
        }
      }
    }
  }
}

export default Snackbar
